export const ERA5WAVEMODELLING = {
  title: {
    value: 'Global-AT_ERA5 for wave modelling',
  },
  paragraph: {
    value: `This data set is based on the ERA5 data set. It consists of an additional variable for wind speed at 10m, with wind speeds > 12 m/s corrected by DHI for wave model forcing.`,
  },
  table: {
    value: {
      header: ['General', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          General: 'Title',
          Model: 'Global-AT_ERA5 for wave modelling',
        },
        {
          General: 'Geographical Coverage',
          Model: 'Global',
        },
        {
          General: 'Category',
          Model: 'Meteorological Parameters',
        },
        {
          General: 'Source Name',
          Model: 'ECMWF Reanalysis v5 (ERA5), Selected Hourly Time-series products, modified by DHI',
        },
        {
          General: 'Publisher',
          Model: 'European Center for Medium-Range Weather Forecasts (ECMWF), DHI',
        },
        {
          General: 'Product type',
          Model: 'Grid',
        },
        {
          General: 'Cost (ex. VAT)',
          Model: 'Free',
        },
        {
          General: 'Typical Applications',
          Model: 'Wave modelling',
        },
        {
          General: 'References',
          Model: `ECWMF ERA5 documentation: ***https://confluence.ecmwf.int/display/CKB/ERA5%3A+data+documentation#heading-TheIFSanddataassimilation***
        ERA5 dataset description: ***https://cds.climate.copernicus.eu/cdsapp#!/dataset/reanalysis-era5-single-levels?tab=overview***
        DHI modifications: ***https://www.metocean-on-demand.com/fileshare/getfile.ashx?type=document&file_name=11824836_EUDP_Global_Atlas_of_Siting_ERA5_Wind_Validation_Version1_2023-06-07.pdf***
          `,
        },
      ],
    },
  },
  table1: {
    value: {
      header: ['Coverage', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Coverage: 'Geographical Range',
          Model: 'Global Longitude: -180°W to 180°E, Latitude: -90°S to 90°N',
        },
        {
          Coverage: 'Geographical Resolution',
          Model: `0.25 degree `,
        },
        {
          Coverage: 'Vertical Reference',
          Model: 'Sea Surface',
        },
        {
          Coverage: 'Temporal Reference',
          Model: 'UTC',
        },
        {
          Coverage: 'Temporal Range',
          Model:
            'Data Link coverage: 1/1-1979 -> Present',
        },
        {
          Coverage: 'Temporal Resolution',
          Model: '1 hour',
        },
      ],
    },
  },
  table2: {
    value: {
      header: ['Variables', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Variables: 'Name (Unit)',
          Model: `Wind velocity components (Speed & direction) at 10m [m/s]`,
        },
      ],
    },
  },  
};
